import { render, staticRenderFns } from "./TwoFactorModal.vue?vue&type=template&id=656899a2&scoped=true"
import script from "./TwoFactorModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorModal.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorModal.vue?vue&type=style&index=0&id=656899a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656899a2",
  null
  
)

export default component.exports